import { useRef, useState } from 'react';

export const YAHOO_LOOKUP_FIELDS = {
  yahooGeo: 'yahoo-geo', yahooGeoExcluded: 'yahoo-geo',
  yahooSegments: 'yahoo-audience', yahooCategories: 'yahoo-category',
};
export default function YahooTargetingPicker({ field, row, onLookup, value, onChange }) {
  const [query, setQuery] = useState(''), [results, setResults] = useState([]);
  const [busy, setBusy] = useState(false), [message, setMessage] = useState('');
  const generation = useRef(0);
  const search = async () => {
    const run = ++generation.current;
    setBusy(true); setMessage(''); setResults([]);
    try {
      const matches = await onLookup(YAHOO_LOOKUP_FIELDS[field], query.trim(), { field, row });
      if (run !== generation.current) return;
      setResults(matches); if (!matches.length) setMessage('No matches. Try a more specific name.');
    } catch (e) { if (run === generation.current) setMessage(e.message || 'Yahoo lookup failed.'); }
    finally { if (run === generation.current) setBusy(false); }
  };
  return <div className="clw-cell-detail-list-note">
    <p>Changes apply to every flight of this line. Search Yahoo for a verified ID, then save the complete list above. Remove an ID from the list to exclude it from this selection.</p>
    <input aria-label="Search Yahoo targeting" value={query} onChange={(e) => {
      ++generation.current; setQuery(e.target.value); setResults([]); setMessage(''); setBusy(false);
    }} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); if (query.trim()) search(); } }} />
    <button type="button" className="clw-btn clw-btn-secondary clw-btn-sm" disabled={!query.trim() || busy} onClick={search}>{busy ? 'Searching…' : 'Search Yahoo'}</button>
    {message && <p role="status">{message}</p>}
    <ul>{results.map((r) => <li key={r.id}><button type="button" onClick={() => {
      const current = String(value || '').split(/[,\n]/).map((v) => v.trim()).filter(Boolean);
      onChange([...new Set([...current, String(r.id)])].join(', '));
    }}>{r.label} · {r.id}{r.country ? ` · ${r.country}` : ''}{r.level ? ` · ${r.level}` : ''}</button></li>)}</ul>
  </div>;
}
